module.exports = __webpack_public_path__ + "fonts/Golos-Text_Bold.3632bc7.woff";